<template>
<div class='bodyer contact'>
    <div class='module map'>
        <div class='container'>
            <div class='title'>联系我们 CONTACT US</div>
            <br>
            <div id='map'></div>
            <br><br>
            <div class='tip'>商务合作 BUSINESS COOPERATION</div>
            <div class='tip'>商务合作联系 carloskim@unnda.com</div>
        </div>
    </div>
</div>
</template>
<script>
export default {
	mounted : function(){
        var map = new AMap.Map('map', {
           center:[106.528404,29.582886],
           zoom:18
        });

        var marker = new AMap.Marker({
            content: '<img src="/static/image/contact/maker.png" style="width:500px;height:160px">',
            position:  [106.528404,29.582886],
            offset: new AMap.Pixel(-20, -80)
        });

        map.add(marker);	
    },
    created : function(){
        window.scrollTo(0, 0)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/about/Contact.vue